import React, { useEffect, useState } from 'react';
import { Minus, Plus, Zap } from 'lucide-react';
import { useFlavour } from '../context/FlavourContext';
import { useCart } from '../context/CartContext';
import { useWoo } from '../context/WooContext';
import { useLang } from '../context/LanguageContext';

export default function StickyPurchaseBar() {
  const { flavour } = useFlavour();
  const { addItem } = useCart();
  const { priceOf, money } = useWoo();
  const { t } = useLang();
  const [show, setShow] = useState(false);
  const [qty, setQty] = useState(1);

  const available = flavour.available !== false && !!flavour.woo;
  const unit = available ? priceOf(flavour.woo) : null;

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const add = () => {
    if (!available) return;
    addItem({
      key: `single-${flavour.id}`,
      title: `S-MAN ${flavour.name} — 1 Box`,
      flavour: flavour.id,
      price: unit || 0,
      qty,
      boxes: 1,
      type: 'single',
      color: flavour.primary,
      rgb: flavour.rgb,
      wooItems: [{ id: flavour.woo, quantity: 1 }],
    });
  };

  return (
    <div
      className={`fixed z-[70] left-0 right-0 bottom-0 md:bottom-6 md:left-auto md:right-6 transition-all duration-500 ${show ? 'translate-y-0 opacity-100' : 'translate-y-full md:translate-y-8 opacity-0 pointer-events-none'}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.22,1,0.36,1)' }}
    >
      <div className="flavour-transition mx-auto md:mx-0 md:rounded-2xl bg-[#0b0b0b]/95 backdrop-blur-xl border-t md:border border-white/10 px-4 py-3 md:px-5 md:py-4 flex items-center gap-3 shadow-2xl md:w-[440px]"
        style={{ boxShadow: `0 0 40px -10px rgba(${flavour.rgb},0.4)` }}>
        <div className="flex items-center gap-2.5 flex-1 min-w-0">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0" style={{ background: `rgba(${flavour.rgb},0.15)` }}>
            <Zap className="w-5 h-5" style={{ color: flavour.primary }} fill={flavour.primary} />
          </div>
          <div className="min-w-0">
            <p className="font-cond text-base tracking-wide leading-tight whitespace-nowrap" style={{ color: flavour.primary }}>{flavour.name}</p>
            <p className="font-display text-lg leading-none">{available ? money(unit) : `FROM ${flavour.comingSoon || 'SOON'}`}</p>
          </div>
        </div>
        <div className="hidden md:flex items-center gap-1.5">
          <button onClick={() => setQty((q) => Math.max(1, q - 1))} className="w-7 h-7 rounded-md border border-white/15 flex items-center justify-center hover:bg-white/10"><Minus className="w-3.5 h-3.5" /></button>
          <span className="w-5 text-center text-sm">{qty}</span>
          <button onClick={() => setQty((q) => q + 1)} className="w-7 h-7 rounded-md border border-white/15 flex items-center justify-center hover:bg-white/10"><Plus className="w-3.5 h-3.5" /></button>
        </div>
        <button
          onClick={add}
          disabled={!available}
          data-testid="sticky-add-btn"
          className="flavour-transition shrink-0 px-4 md:px-5 py-2.5 rounded-lg font-cond tracking-wide text-sm text-black hover:brightness-110 transition-all disabled:opacity-40"
          style={{ background: flavour.primary }}
        >
          <span className="md:hidden">{t('add')} +</span>
          <span className="hidden md:inline">{t('addToCart')} →</span>
        </button>
      </div>
    </div>
  );
}
